import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { href as rhref } from "react-router";

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

export const href = (
	template: string,
	params: Record<string, string>,
	query?: URLSearchParams,
) => {
	const escapedParams: Record<string, string> = {};
	for (const [k, v] of Object.entries(params)) {
		escapedParams[k] = encodeURIComponent(v).replace(/%40/, "@");
	}
	const url = rhref(template, escapedParams);
	return url + (query?.size ? "?" + query : "");
};
